import {fabric} from 'fabric'
export function makeAnnotation(canvas) {
    let selectedShape;
    let pointer;
    let linex,liney,arrowx,arrowy
    // let startX, startY, origX, origY;
    let  line, arrow;

    let stroke = 'black';
    let fill = 'transparent';
    canvas.on('mouse:down', function(option) {

       // if(option.target != null) {
       //     return;
       // } else {
        if((option.target == null) || (option.target.type === 'image') ){
            pointer = canvas.getPointer(option.e);
            let arrowLinePoints = [pointer.x, pointer.y, pointer.x, pointer.y];

            // startX = pointer.x;
            // startY = pointer.y;

            line = new fabric.Line(arrowLinePoints, {
                fill: fill,
                stroke: stroke,
            });

            // reference points for arrowhead
            // origX = line.x2;
            // origY = line.y2;

            let dx = line.x2 - line.x1,
                dy = line.y2 - line.y1;

            /* calculate angle of arrow */
            let angle = Math.atan2(dy, dx);
            angle *= 180 / Math.PI;
            angle += 90;
            angle += 180;

            arrow = new fabric.Triangle({
                angle: angle,
                fill: 'black',
                top: line.y2,
                left: line.x2,
                width: 7,
                height: 7,
                originX: 'center',
                originY: 'center',
                stroke: stroke
            });

            canvas.add(line);
            canvas.add(arrow);

            canvas.renderAll();

            canvas.on("mouse:move", function(option) {
                pointer = canvas.getPointer(option.e);

                line.set({
                    x2: pointer.x,
                    y2: pointer.y,
                });

                let dx = line.x2 - line.x1,
                    dy = line.y2 - line.y1;

                let angle = Math.atan2(dy, dx);
                angle *= 180 / Math.PI;
                angle += 90;
                angle += 180;
                arrow.set({angle:angle})
                linex= line.left;
                liney= line.top;
                arrowx = arrow.left;
                arrowy = arrow.top;

                canvas.renderAll();

            });

        }
    });

    canvas.on('mouse:up', function(option) {


        canvas.off('mouse:move');
        canvas.off('mouse:down');
        canvas.off('mouse:up');
        // canvas.deactivateAll();
        canvas.remove(line);
        canvas.remove(arrow);
        arrow.set({left:arrowx,top:arrowy});
        line.set({left:linex,top:liney});
        let text;
        if(line && arrow){
            selectedShape = new fabric.Group([line, arrow], {
                hasBorders: true,
                hasControls: true,
            });
            text = new fabric.Textbox('', {
                top: line.y2 - 10,
                left: line.x2 + 2,
                fontSize: 12,
                opacity:1,
                width:200,
                fontFamily: 'Verdana',
                backgroundColor:'aliceblue',
            });

            
            
            canvas.add(selectedShape);
            canvas.add(text);
            // selectedShape.addWithUpdate(text);

            text.enterEditing();

            canvas.on('text:changed', function(opt) {
                text.set({
                    width: text?.text?.length + 10
                })
            });
        }
    });




 }
